export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'Ashlar App',
  tagline: import.meta.env.VITE_APP_TAGLINE || 'The Modern Platform for Real Estate Appraisers',
  description: 'Ashlar App is the modern platform for real estate appraisers — USPAP-compliant workfile management, professional report templates, public records integration, and your own branded website.',
};

/** Feature flags. */
export const FEATURES = {
  /**
   * grid-overhaul Phase 3: persist + read the unified comparable adjustment shape
   * (`adjustment_metadata`) alongside the legacy fields. Default OFF until verified
   * on real data — flip with `VITE_GRIDS_V2=true`. When off, persistence is
   * byte-identical to today; when on, the unified shape is ADDED, legacy never removed.
   */
  gridsV2: import.meta.env.VITE_GRIDS_V2 === 'true',
};
